import { render, staticRenderFns } from "./HuePanelControls.vue?vue&type=template&id=53771385&scoped=true&"
import script from "./HuePanelControls.vue?vue&type=script&lang=js&"
export * from "./HuePanelControls.vue?vue&type=script&lang=js&"
import style0 from "./HuePanelControls.vue?vue&type=style&index=0&id=53771385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53771385",
  null
  
)

export default component.exports